import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { blogPosts } from "@/content/blogPosts";

const BlogSection = () => {
  const posts = blogPosts.slice(0, 3);

  return (
    <section aria-labelledby="latest-blog-heading" className="bg-background py-16">
      <div className="container mx-auto px-4">
        <header className="mb-8 text-center">
          <h2 id="latest-blog-heading" className="text-3xl font-bold text-foreground">Latest from the blog</h2>
          <p className="text-muted-foreground mt-2">Insights on payments, POS systems, and online ordering</p>
        </header>
        <div className="grid gap-6 md:grid-cols-3">
          {posts.map((post) => (
            <article key={post.slug} className="h-full">
              <Card className="h-full flex flex-col">
                <CardHeader>
                  <CardTitle className="text-xl text-foreground">{post.title}</CardTitle>
                  <CardDescription>
                    <span className="text-xs uppercase tracking-wide">{post.category}</span>
                    <span className="mx-2">•</span>
                    <time dateTime={post.date}>{new Date(post.date).toLocaleDateString()}</time>
                  </CardDescription>
                </CardHeader>
                <img
                  src={post.image}
                  alt={`${post.title} - Processing Bros blog`}
                  loading="lazy"
                  decoding="async"
                  width="400"
                  height="176"
                  className="w-full h-44 object-cover"
                />
                <CardContent className="flex-1 flex flex-col">
                  <p className="text-muted-foreground mb-4">{post.excerpt}</p>
                  <div className="mt-auto">
                    <Button asChild>
                      <Link to={`/blog#${post.slug}`}>Read article</Link>
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </article>
          ))}
        </div>
        <div className="text-center mt-10">
          <Button variant="secondary" asChild>
            <Link to="/blog">View all articles</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
